<template>
  <div class="landing">
    <div class="container-fluid">
      <div class="row" style="min-height: 100vh">
        <div class="col-md-6 flex-column d-sm-flex" style="background:black;text-align: center;">
          <img src="img/screen.svg" style="max-width: 80%;margin: auto;">
        </div>
        <div class="col-md-6 my-auto">
          <div class="pl-md-5 pt-5 pt-md-0 pr-md-5">
            <div class="mb-3 locale-changer">
                <select v-model="$root.$i18n.locale">
                    <option value="en">{{ $t("en") }}</option>
                    <option value="ru">{{ $t("ru") }}</option>
                </select>
            </div>
            <h1>Overmatch</h1>
            <h4 class="mb-5">{{ $t('subheader') }}</h4>
            <p class="mt-5">{{ $t('promotional1') }}<br>{{ $t('promotional2') }}<br>{{ $t('promotional3') }}</p>
            <a
              :href="appLink"
              class="app-link rounded bg-secondary mr-2 text-right px-2 position-relative border"
              style="background: url(img/player_logo.svg) no-repeat 0% 0%;box-sizing:border-box;"
            >
              <div class="position-absolute" style="right:5px;line-height:18px"><small class="font-weight-light">{{ $t('open') }}</small><br>Overmatch</div>
            </a>
            <a
              href="https://itunes.apple.com/ru/app/overmatch/id1457499844?mt=8"
              style="display:inline-block;overflow:hidden;background:url(https://linkmaker.itunes.apple.com/en-us/badge-lrg.svg?releaseDate=2009-10-09&kind=iossoftware&bubble=ios_apps) no-repeat;width:135px;height:40px;"
            ></a>
            <p class="mt-3">
              <strong>Overmatch</strong> - {{ $t('description') }}.
            </p>
            <ul>
              <li>
                {{ $t('ifYou', [$t('LeagueManager').toLowerCase()]) }}:
                <ul>
                  <li>{{ $t('sales.org_tourn') }};</li>
                  <li>{{ $t('sales.control_season') }};</li>
                  <li>{{ $t('sales.see_stat') }};</li>
                  <li>{{ $t('sales.live_broadcast') }};</li>
                  <li>{{ $t('sales.publish_league_news') }};</li>
                </ul>
              </li>
              <li>
                {{ $t('ifYou', [$t('TeamManager').toLowerCase()]) }}:
                <ul>
                  <li>{{ $t('sales.control_team') }};</li>
                  <li>{{ $t('sales.invite_new_player') }};</li>
                  <li>{{ $t('sales.publish_team_news') }};</li>
                </ul>
              </li>
              <li>
                {{ $t('ifYou', [$t('Footballer').toLowerCase()]) }}:
                <ul>
                  <li>{{ $t('sales.search_team') }};</li>
                  <li>{{ $t('sales.be_in_match') }};</li>
                  <li>{{ $t('sales.see_career') }};</li>
                </ul>
              </li>
              <li>
                {{ $t('ifYou', [$t('fan').toLowerCase()]) }}:
                <ul>
                  <li>{{ $t('sales.see_team_news') }};</li>
                </ul>
              </li>
            </ul>
            {{ $t('andMuchMore') }}
          </div>
        </div>
      </div>
      <div class="row report-background">
        <FeedbackForm ref="feedback" class="col-md-6 report-container" :submitBtnAnimating="submitBtnAnimating" @submit="onSubmit">
          <template v-slot:result>
            <slot name="result"></slot>
          </template>
        </FeedbackForm>
      </div>
    </div>
  </div>
</template>

<script>
import FeedbackForm from "@/components/forms/FeedbackForm.vue";

export default {
  components: { FeedbackForm },
  props: ['submitBtnAnimating'],
  computed: {
    appLink() {
      return 'app.html#/?lang=' + this.$root.$i18n.locale;
    }
  },
  i18n: {
    messages: {
      en: {
        subheader: "Football in your region",
        promotional1: "Create a football space of your district, city and region.",
        promotional2: "Manage your career, team and league.",
        promotional3: "Follow the statistics, set yourself new goals.",
        description: "an app for players, team and league managers, and just football fans",
        ifYou: "If you're a {0}",
        open: "Open",
        fan: "fan",
        sales: {
          org_tourn: "organize tournaments",
          control_season: "manage the course of the season",
          see_stat: "watch the statistics",
          live_broadcast: "conduct text broadcasts of matches",
          publish_league_news: "publish news of the league",
          control_team: "manage your team",
          invite_new_player: "invite new players",
          publish_team_news: "publish team news",
          search_team: "look for teams",
          be_in_match: "participate in matches",
          see_career: "follow the development of your career",
          see_team_news: "stay up to date with the news of your favorite teams"
        },
        andMuchMore: "and much more..."
      },
      ru: {
        subheader: "Футбол твоего региона",
        promotional1: "Создавай футбольное пространство своего района, города и региона.",
        promotional2: "Зарегистрируй свою команду и лигу, играй в лучших командах.",
        promotional3: "Следи за статистикой, ставь себе новые цели.",
        description: "приложение для игроков, менеджеров команд и лиг, и просто любителей футбола",
        ifYou: "Если ты {0}",
        open: "Открыть",
        fan: "болельщик",
        sales: {
          org_tourn: "организуй турниры",
          control_season: "управляй ходом сезона",
          see_stat: "следи за статистикой",
          live_broadcast: "веди текстовые трансляции матчей",
          publish_league_news: "публикуй новости лиги",
          control_team: "управляй составом команды",
          invite_new_player: "приглашай новых игроков",
          publish_team_news: "публикуй новости команды",
          search_team: "ищи команды",
          be_in_match: "участвуй в матчах",
          see_career: "следи за развитием своей карьеры",
          see_team_news: "будь в курсе новостей своих любимых команд"
        },
        andMuchMore: "и многое другое..."
      }
    }
  },
  methods: {
    onSubmit(event, email, message) {
      this.$emit('submit', event, email, message);
    },
    resetFeedback() {
      this.$refs.feedback.reset();
    }
  }
}
</script>


<style>
.report-background {
  background: var(--secondary);
  border-top: 1px solid #eee;
}
.report-container {
  padding: 40px;
  margin: 0 auto;
}

.app-link {
  display: inline-block;
  overflow: hidden;
  width: 135px;
  height: 40px;
}

@media (min-width: 1000px) {
  .report-container {
    width: 50%;
  }
}
</style>
